export default __webpack_public_path__ + "assets/models/4a33e75867aa477df07f764b848d8381.glb";